module.exports = __webpack_public_path__ + "img/join_car.e6f4544e.png";